import EditIcon from "@mui/icons-material/Edit";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import { ScrapEyesEvent } from "components/scrapEyeLabelling/types";
import { useTenantTranslation } from "hooks/formatters";
import { eventTypeColor } from "components/scrapEyeDataDashboard/VideoPlayer/utils";

interface EventDetailsSectionProps {
  event: ScrapEyesEvent;
  onOpenCommentModal?: () => void;
}

export const EventDetailsSection = ({
  event,
  onOpenCommentModal,
}: EventDetailsSectionProps) => {
  const { t } = useTenantTranslation();

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 1.5, fontWeight: 600 }}>
        {t("eventDetails")}
      </Typography>
      <Stack spacing={1}>
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="body2" color="text.secondary">
            {t("type")}:
          </Typography>
          <Box
            sx={{
              px: 1,
              py: 0.5,
              borderRadius: 1,
              backgroundColor: eventTypeColor(event.eventType),
              border: `1px solid ${eventTypeColor(event.eventType)}`,
            }}
          >
            <Typography
              variant="caption"
              sx={{
                color: "white",
                fontWeight: "bold",
              }}
            >
              {event.eventType.toUpperCase()}
            </Typography>
          </Box>
          {onOpenCommentModal ? (
            <IconButton
              size="small"
              color={event.comment ? "primary" : "default"}
              onClick={onOpenCommentModal}
            >
              <EditIcon fontSize="small" />
            </IconButton>
          ) : null}
        </Stack>

        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="body2">
            {event.start.utc().format("YYYY-MM-DD HH:mm:ss.SSS")}
          </Typography>
          <Typography variant="body2" fontWeight={600}>
            -
          </Typography>
          <Typography variant="body2">
            {event.end.utc().format("YYYY-MM-DD HH:mm:ss.SSS")}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="body2" color="text.secondary">
            {t("duration")}:
          </Typography>
          <Typography variant="body2">
            {Math.round(event.end.diff(event.start, "seconds", true))}{" "}
            {t("seconds")}
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
};
